export const ACCOUNT_CREATION_REQUEST = 'ACCOUNT_CREATION_REQUEST'
export const ACCOUNT_CREATION_SUCCESS = 'ACCOUNT_CREATION_SUCCESS'
export const ACCOUNT_CREATION_RESET = 'ACCOUNT_CREATION_RESET'
export const ACCOUNT_CREATION_ERROR = 'ACCOUNT_CREATION_ERROR'
